import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';
import { Http, Headers } from '@angular/http';
import { AppConfig } from 'app/app.config';
import { Translation } from 'app/entities/Translation';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';

@Injectable()
export class TranslationService {

  apiUrl: string;
  public translations: Map<string, Translation>;
  public translationsSub: BehaviorSubject<Map<string, Translation>> = new BehaviorSubject<Map<string, Translation>>(null);
  public solution: string = this.config.getConfig("solution");
  language: BehaviorSubject<string>;

  constructor(private http: Http,
    private connectionService: ConnectionService,
    private config: AppConfig,
    public location: Location,
  ) {
    this.apiUrl = config.getConfig('endPointApiUrl');
    this.language = new BehaviorSubject<string>(this.location.path().split('/')[1])
  }

  
  /**
   *  returns the translation of a property it it exits, else it returns mission tranlation
  *
  * @param {string} property
  * @return {*}  {string}
  * @memberof TranslationService
  */
  getTranslation(property: string, placeholder: string[] = []): string {
    const separator = '||'
    if (this.translations && this.translations[property]) {
      let translation: string = this.translations[property].Translation; 
      if (translation.includes(separator) && placeholder.length > 0){
        translation = this.replacePlaceholderValuesInString(translation, placeholder, separator)
      }
      return translation
    }
    else {
      return `Missing Translation: ${property}`;
    }
  }

  replacePlaceholderValuesInString(translation: string, placerholderValues: string[], separator: string): string{
    placerholderValues.forEach((placeholderValue) => {
      translation = translation.replace(separator, placeholderValue);
    })
    return translation;
  }


  
  /**
   * returns the language subject of the service
  *
  * @return {*}  {BehaviorSubject<string>}
  * @memberof TranslationService
  */
  getLanguageSubject(): BehaviorSubject<string> {
   return this.language;
  }
 
  getTranslations(solution: string, languageCode: string): Map<string, Translation> {
    if (this.translations !== undefined) {
      // Find the first entry in this.translations and get the Language_Code. For some reason, this.translations doesnt have the Map methods, so I'm using Object instead and that works.
      const currentLanguageCode = this.translations[Object.keys(this.translations)[0]].Language_Code
      if (currentLanguageCode === languageCode) {
        return this.translations;
      }
    }
    const translationSub = this.getTranslationsData(solution, languageCode).subscribe(result => {
      this.translations = result;
      return result;
    }, error => console.log(error), () => translationSub.unsubscribe())
  }
  
  /**
   * returns an observable string array of languages.
   *
   * @param {string} [solution=this.config.getConfig("solution")]
   * @return {*}  {Observable<string[]>}
   * @memberof TranslationService
   */
  getLanguages(solution: string = this.config.getConfig("solution")): Observable<string[]> {
    let url = this.apiUrl + 'api/Translations/' + solution;
    return this.http
    .get(url, { headers: this.headers() })
    .map(response => response.json());
  }
  
  /**
   * Sets the language key on the language subject
   *
   * @param {string} language
   * @memberof TranslationService
   */
  setLanguage(language: string) {
    this.language.next(language);
    this.loadTranslations();
  }
  
  /**
   * loads translations from the api into the services translations map
   *
   * @memberof TranslationService
   */
  loadTranslations() {
    this.language.do(language => {
      this.getTranslationsData(this.solution, language).do((translations) => {
        this.translations = translations;
        this.translationsSub.next(translations);
      }).take(1).subscribe();
    }).take(1).subscribe();
  }

  setTranslations(language: string) {
      this.getTranslationsData(this.solution, language).do((translations) => {
        this.translations = translations;
        this.translationsSub.next(translations);
      }).take(1).subscribe();

  }

  /**
   * Send get request to api for getting the translations map
   *
   * @private
   * @param {string} solution
   * @param {string} languageCode
   * @return {*}  {Observable<Map<string, Translation>>}
   * @memberof TranslationService
   */
  private getTranslationsData(solution: string, languageCode: string): Observable<Map<string, Translation>> {
    const url = this.apiUrl + 'api/Translations/' + solution + '/' + languageCode;
    return this.http
    .get(url, { headers: this.headers() })
    .map(response => response.json());
  }
  
  /**
   * used to set the headers of the getTranslations request
   *
   * @private
   * @param {*} [company=null]
   * @return {*}  {Headers}
   * @memberof TranslationService
   */
  private headers(company: string = null): Headers {
    return this.connectionService.GetAuthorizationHeader(company);
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/translation.service.ts